(() => {
  const prioritizeInitialGalleryMedia = () => {
    const image = document.querySelector('[data-pdp-gallery-item="0"] img');
    if (!image) return false;
    image.loading = 'eager';
    image.fetchPriority = 'high';
    return true;
  };

  if (prioritizeInitialGalleryMedia()) return;

  const observer = new MutationObserver(() => {
    if (prioritizeInitialGalleryMedia()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('DOMContentLoaded', () => {
    if (prioritizeInitialGalleryMedia()) observer.disconnect();
  }, { once: true });
})();
